import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["id"];
import { watchEffect, onUnmounted } from "vue";
import * as echarts from 'echarts';
import { nextTick } from 'vue';
export default {
  __name: 'barAnalysis',
  props: {
    id: {
      type: String,
      default: 'echart'
    },
    data: {
      type: Object,
      default: function _default() {}
    },
    yAxis1: {
      type: String,
      default: ''
    },
    yAxis2: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    // const data = {
    //   title: '本周课堂组织情况',
    //   legend: ['用课平台次数', '学程授课占比', '展示次数占比', '有展示课次学生参与率'],
    //   xAxis: ['六年级', '七年级', '八年级', '九年级', '高一', '高二', '高三'],
    //   series: [
    //     { name: '用课平台次数', data: [300, 650, 1700, 520, 639, 500, 300] },
    //     { name: '学程授课占比', data: [0.6, 0.8, 0.4, 0.8, 0.95, 0.6, 0.5] },
    //     { name: '展示次数占比', data: [0.8, 0.6, 0.6, 0.8, 0.3, 0.4, 0.955] },
    //     { name: '有展示课次学生参与率', data: [0.8, 0.95, 0.6, 0.5, 0.4, 0.8, 0.6] },
    //   ],
    // }
    var series = [{
      name: '',
      type: 'bar',
      barWidth: '20px',
      yAxisIndex: 0,
      itemStyle: {
        color: '#366EF4'
      },
      data: []
    }, {
      name: '',
      type: 'line',
      yAxisIndex: 1,
      smooth: true,
      showSymbol: false,
      itemStyle: {
        color: '#0AC9D0'
      },
      data: []
    }, {
      name: '',
      type: 'line',
      yAxisIndex: 1,
      smooth: true,
      showSymbol: false,
      itemStyle: {
        color: '#3FDEB1'
      },
      data: []
    }, {
      name: '',
      type: 'line',
      yAxisIndex: 1,
      smooth: true,
      showSymbol: false,
      itemStyle: {
        color: '#FFA63A'
      },
      data: []
    }];
    // let roundUpFirstDecimal = (num) => {
    //   // 转换为字符串以便检查小数部分
    //   // const strNum = Math.ceil(num);
    //   const strNum = num.toString()
    //   const decimalIndex = strNum.indexOf('.')
    //   let endIndex = decimalIndex === -1 ? strNum.length : decimalIndex
    //   return Math.ceil(num / Math.pow(10, endIndex - 1)) * Math.pow(10, endIndex - 1)
    //   // return strNum;
    // }

    // let getMaxY = (list) => {
    //   const max = Math.max(...list) / 5
    //   // console.log(max)
    //   return roundUpFirstDecimal(max) * 5
    // }
    var timer = null;
    var echartData = function echartData(data) {
      // console.log(data, 90)
      var dom = document.getElementById(props.id);
      if (!dom) return;
      var myChart1 = echarts.init(dom);
      window.addEventListener('resize', function () {
        myChart1.resize();
      });
      var newSeries = data.series.map(function (item, index) {
        return _objectSpread(_objectSpread({}, series[index]), {}, {
          name: item.name,
          data: item.data.filter(function (itm) {
            return Number(itm) > 0;
          })
        });
      });
      var xAxis = data.xaxis.filter(function (itm, index) {
        var isSome = data.series.some(function (it) {
          return it.data[index] > 0;
        });
        return isSome;
      });
      // const yAxis1 = newSeries.map(it => {
      //   return Math.max(...it.data)
      // })
      // const yAxis2 = newSeries.map(it => {
      //   return Math.max(...it.data)
      // })
      // const maxY = Math.max(...yAxis1, ...yAxis2)
      // console.log(maxY, 99)
      newSeries.forEach(function (item, index) {});
      var option = {
        title: {
          text: data.title,
          left: 'left',
          show: data.showTitle
        },
        tooltip: {
          trigger: 'axis'
        },
        yAxis: [{
          type: 'value',
          name: props.yAxis1,
          position: 'left',
          min: 0
        }, {
          type: 'value',
          name: props.yAxis2,
          position: 'right',
          axisLabel: {
            formatter: function formatter(value) {
              return "".concat(value);
            }
          }
        }],
        legend: {
          top: 0,
          data: data.legend,
          show: data.showLegend
        },
        /*dataZoom: [
          {
            type: 'slider',
            start: 0,
            end: 100,
            maxValueSpan: 14,
          },
        ],*/
        xAxis: {
          type: 'category',
          axisLabel: {
            rotate: 45,
            interval: 0
          },
          data: xAxis
        },
        series: newSeries.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            barWidth: 12,
            barGap: '50%'
          });
        })
      };
      if (data.isRate) {
        option.yAxis = [{
          type: 'value',
          name: props.yAxis1,
          position: 'left',
          min: 0,
          axisLabel: {
            formatter: function formatter(value) {
              return "".concat(value, "%");
            }
          }
        }];
      } else {
        option.yAxis = [{
          type: 'value',
          name: props.yAxis1,
          position: 'left',
          min: 0,
          axisLabel: {
            formatter: function formatter(value) {
              return "".concat(value);
            }
          }
        }
        // {
        //   type: 'value',
        //   name: props.yAxis2,
        //   position: 'right',
        //   axisLabel: {
        //     formatter: (value) => {
        //       return `${value}`
        //     },
        //   },
        // },
        ];
      }
      option && myChart1.setOption(option);
      timer = setTimeout(function () {
        myChart1.resize();
      }, 100);
    };
    watchEffect(function () {
      if (props.data && Object.keys(props.data).length > 0) {
        nextTick(function () {
          echartData(props.data);
        });
      }
    });
    onUnmounted(function () {
      if (timer) {
        clearTimeout(timer);
      }
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        id: __props.id,
        style: {
          "width": "100%",
          "height": "300px"
        }
      }, null, 8, _hoisted_1);
    };
  }
};